export default __webpack_public_path__ + "static/media/penguin-6.dbf2f839.png";